import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@core/core.module';
import { SpinnerInterceptor } from '@core/interceptors/spinner.interceptor';
import { SharedModule } from '@shared/shared.module';
import { QRCodeModule } from 'angularx-qrcode';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ComponentsModule } from 'src/app/components/components.module';
import { MaterialModule } from 'src/app/material.module';
import { DialogGroupBox } from './components/dialog-group.component';
import { LinePhoneView } from './components/line-phone-view/line-phone-view.component';
import { LinesGroupsRoutingModule } from './lines-groups-routing.module';
import { CreateEditLineComponent } from './pages/create-edit-line/create-edit-line.component';
import { DialogViewCampaignComponent } from './pages/dialog-view-campaign/dialog-view-campaign.component';
import { LinesCampainsComponent } from './pages/lines-campains/lines-campains.component';
import { ListsLineComponent } from './pages/lists-line/lists-line.component';

@NgModule({
  declarations: [
    ListsLineComponent,
    CreateEditLineComponent,
    LinePhoneView,
    DialogGroupBox,
    LinesCampainsComponent,
    DialogViewCampaignComponent,
  ],
  imports: [
    CommonModule,
    LinesGroupsRoutingModule,
    FormsModule,
    MaterialModule,
    HttpClientModule,
    ReactiveFormsModule,
    CoreModule,
    SharedModule,
    ComponentsModule,
    NgxDropzoneModule,
    QRCodeModule,
    ColorPickerModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  ],
})
export class LinesGroupsModule {}
